const cookie = document.cookie;

export const API_BASE_URL =
  process.env.REACT_APP_BASE_API || "https://api.nazerkhodro.com/api/v1/admin";
// export const API_BASE_URL = localStorage.getItem("projectURL");
// https://api.ccme.ir/api/V1/admin

export const AXIOS_HEDERS = {
  headers: { Authorization: "Bearer " + cookie.split("=")[1] },
};
export const AXIOS_HEADERS_FILE = {
  headers: {
    Authorization: "Bearer " + cookie.split("=")[1],
    "Content-Type": "multipart/form-data",
  },
};
export const AXIOS_HEDERS_Authorization = {
  Authorization: "Bearer " + cookie.split("=")[1],
};
